import { render, staticRenderFns } from "./Pagination.vue?vue&type=template&id=c4b23ab0&"
import script from "./Pagination.controller.js?vue&type=script&lang=js&"
export * from "./Pagination.controller.js?vue&type=script&lang=js&"
import style0 from "./Pagination.styles.scss?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports